import React, { useState, useEffect } from 'react';
import './Refund.css';
import comuniItaliani from './gi_comuni.json';
import capItaliani from './gi_cap.json';
import { loadCaptchaEnginge, LoadCanvasTemplateNoReload, validateCaptcha } from 'react-simple-captcha';
import constants from '../Utils/constants.js'
import { useNavigate } from 'react-router-dom';

//*check input
function checkRequired(fd, f, re) {
    let fv = fd.get(f)
    if(fv === null) return false
    //console.log(`${f}:${fv}`)
    return re.test(fv)
}
function checkRequiredArray(values, re) {
    return values.map(value => re.test(value));
}

function Refund() {
    //*navigate constant
    const navigate = useNavigate()

    //*captha creating variable
    const captchaLen = 6;
    const [captcha, setCaptcha] = useState('');

    //*check input variable
    const [okName, setOkName] = useState(true);
    const [okCity, setOkCity] = useState(true);
    const [okProv, setOKProv] = useState(true);
    const [okCap, setOkCap] = useState(true);
    const [okAddress, setOkAddress] = useState(true);
    const [okContact, setOkContact] = useState(true);
    const [okTel, setOkTel] = useState(true);
    const [okMail, setOkMail] = useState(true);
    const [okRif, setOkRif] = useState(true);
    const [okDif, setOkDif] = useState(true);
    const [okColli, setOkColli] = useState(true);
    const [okAm, setOkAm] = useState(true);
    const [okAc, setOkAc] = useState(true);
    const [okPm, setOkPm] = useState(true);
    const [okPc, setOkPc] = useState(true);
    const [okCaptcha, setOkCaptcha] = useState(true);
    let okDay = false;

    //*add order variable
    const [inputSets, setInputSets] = useState([{ cod: '', serial: '', isValid: true }]);

    //*modal style
    const [isModalChanged, setIsModalChanged] = useState(false);

    //*response variable
    const [responseText, setResponseText] = useState('');
    const [okResponse, setOkResponse] = useState(true);

    //*fill field variable
    const [city, setCity] = useState('');
    const [prov, setProv] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const [isFocused, setIsFocused] = useState(false);
    const [selectedCodiceIstat, setSelectedCodiceIstat] = useState('');
    const [capSuggestions, setCapSuggestions] = useState([]);

    //*code to add and remove order
    const handleAddInputs = () => {
        setInputSets([...inputSets, { cod: '', serial: '', isValid: true }]);
    };
    const handleInputChange = (index, field, value) => {
        const newInputSets = [...inputSets];
        newInputSets[index][field] = value;
        newInputSets[index].isValid = true;
        setInputSets(newInputSets);
    };
    const handleRemoveInputs = (indexToRemove) => {
        setInputSets(prevSets => prevSets.filter((_, index) => index !== indexToRemove));
    };

    //*city autocomplete and cap
    useEffect(() => loadCaptchaEnginge(captchaLen), [])

    useEffect(() => {
        if (isFocused && city.length > 1) {
            const filteredCities = Object.values(comuniItaliani)
                .filter(comune => comune.denominazione_ita.toLowerCase().startsWith(city.toLowerCase()))
                .slice(0, 10)
                .map(comune => ({
                    nome: comune.denominazione_ita,
                    provincia: comune.sigla_provincia,
                    istat: comune.codice_istat
                }));
            setSuggestions(filteredCities);
        } else {
            setSuggestions([]);
        }
    }, [city, isFocused]);

    useEffect(() => {
        if (selectedCodiceIstat) {
            const filteredCaps = Object.values(capItaliani)
                .filter(cap => cap.codice_istat === selectedCodiceIstat)
                .map(cap => cap.cap);
            setCapSuggestions(filteredCaps);
        } else {
            const allCaps = [...new Set(Object.values(capItaliani).map(cap => cap.cap))];
            setCapSuggestions(allCaps);
        }
    }, [selectedCodiceIstat]);

    const handleCityChange = (e) => {
        setCity(e.target.value);
        setProv('');
        setSelectedCodiceIstat('');
    };

    const handleFocus = () => {
        setIsFocused(true);
    };

    const handleBlur = () => {
        setTimeout(() => setIsFocused(false), 200);
    };

    const handleSuggestionClick = (suggestion) => {
        setCity(suggestion.nome);
        setProv(suggestion.provincia);
        setSelectedCodiceIstat(suggestion.istat);
        setSuggestions([]);
    };

    //*check input form
    const sendData = () => {
        let fd = new FormData(document.getElementsByName("refund-form")[0])
        let name = checkRequired(fd, 'name', /.+/)
        let city = checkRequired(fd, 'city', /.+/)
        let provi = checkRequired(fd, 'provincia', /.+/)
        let cap = checkRequired(fd, 'cap', /^\d{5}$/)
        let address = checkRequired(fd, 'address', /.+/)
        let contact = checkRequired(fd, 'contact', /.+/)
        let tel = checkRequired(fd, 'tel', /^\d+$/)
        let mail = checkRequired(fd, 'mail', /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/)
        let rif = checkRequired(fd, 'rif', /.+/)
        let dif = checkRequired(fd, 'dif', /.+/)
        let colli = checkRequired(fd, 'colli', /^\d+$/)
        if(!checkRequired(fd, 'am', /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/)) {
            fd.delete("am");
        }
        if(!checkRequired(fd, 'ac', /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/)) {
            fd.delete("ac");
        }
        if(!checkRequired(fd, 'pm', /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/)) {
            fd.delete("pm");
        }
        if(!checkRequired(fd, 'pc', /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/)) {
            fd.delete("pc");
        }
        
        let lun = fd.get('lun') !== null;let mar = fd.get('mar') !== null;let mer = fd.get('mer') !== null;let gio = fd.get('gio') !== null;let ven = fd.get('ven') !== null;let sab = fd.get('sab') !== null;
        
        let street = fd.get('street');
        fd.set('street', street);

        const serialValues = inputSets.map(set => set.serial.trim());
        const processedSerials = serialValues.map(serial => serial === '' ? 'null' : serial);
        const serialString = processedSerials.join(',');

        const codValues = inputSets.map(set => set.cod);
        const codValidity = checkRequiredArray(codValues, /.+/);
        const validCods = codValues.filter((_, index) => codValidity[index]).join(',');

        setInputSets(prevSets => prevSets.map((set, index) => ({
            ...set,
            isValid: codValidity[index]
        })));
        const allCodsValid = codValidity.every(Boolean);

        fd.set('serial', serialString);
        fd.set('cod', validCods);

        if (!(lun || mar || mer || gio || ven || sab)) {
            okDay = false;
            document.querySelector('.title-error-2').style.display = 'inline';
        } else {
            okDay = true;
            document.querySelector('.title-error-2').style.display = '';
        }
        if (!(validateCaptcha(captcha))) {
            setOkCaptcha(false);
        } else {
            setOkCaptcha(true);
        }

        if(!(name && city && provi && cap && address && contact && tel && mail && rif && allCodsValid && dif && colli /*&& am && ac && pm && pc */ && okDay)) {
            updateErrors();
            document.querySelector('.title-error').style.display = 'inline';
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
        else if (validateCaptcha(captcha)) {
            updateErrors();
            document.querySelector('.title-error').style.display = '';
            fetch(`${constants.baseUrl}/refund.php`, {
                method: 'post',
                body: new URLSearchParams(fd),
            })
            .then(r => {
                console.log(r)
                if (r.ok) {
                    return r.text();
                }
                else {
                    throw new Error();
                }
            })
            .then(rma => {
                
                setResponseText(`Richiesta inoltrata con successo: ${rma}`);
                setOkResponse(true);
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
                loadCaptchaEnginge(captchaLen);
                setIsModalChanged(!isModalChanged);
                document.body.style.overflowY = 'hidden';
            })
            .catch(_ => {                
                setResponseText("Errore nell'inoltrare la richiesta");
                setOkResponse(false);
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
                loadCaptchaEnginge(captchaLen);
                setIsModalChanged(!isModalChanged);
                document.body.style.overflowY = 'hidden';
            })
        }
        else {
            updateErrors();
            document.querySelector('.title-error').style.display = '';
        }
        function updateErrors() {
            setOkName(name);setOkCity(city);setOKProv(provi);setOkCap(cap);setOkAddress(address);setOkContact(contact);setOkTel(tel);setOkMail(mail);setOkRif(rif);setOkDif(dif);setOkColli(colli);
            /*setOkAm(am);setOkAc(ac);setOkPm(pm);setOkPc(pc);*/
        }
    }

    //*close modal
    function closeModal() {
        setIsModalChanged(!isModalChanged);
        document.body.style.overflowY = 'scroll';
    }
    function goHome() {
        document.body.style.overflowY = 'scroll';
        navigate('/home');
    }

    return (
        <div className='main-container'>
            <div className={`modal ${isModalChanged ? 'modal-show' : ''}`}>
                <div className={`modal-container ${okResponse ? 'modal-ok' : 'modal-notok'}`}>
                    <h2>{responseText}</h2>
                    <button onClick={event => { event.preventDefault(); goHome();}}><h4>Torna alla home</h4></button>
                    {(okResponse 
                    ?
                        <></>
                    :
                        <button onClick={event => { event.preventDefault(); closeModal();}}><h4>Chiudi</h4></button>
                    )}
                </div>
            </div>

            <div className='refund-container'>
                <h1 className='refund-title'>Richiesta di assistenza</h1>
                <form name='refund-form' id="refund-form" autoComplete='off'>
                    <h2>Informazioni di contatto <span className='title-error'>per favore inserisci tutti i dati richiesti</span></h2>
                    <div className='refund-input-container'>
                        <label className='refund-label' for="name">Nome ente <span className="refund-required">*</span> </label>
                        <input className={okName ? 'refund-input' : 'error-required'} name="name" type="text" required/>
                    </div>

                    <div className='refund-input-container'>
                        <label className='refund-label' For="city">Città e provincia<span className="refund-required">*</span> </label>
                        <div className='refund-input-split'>
                            <input className={`${okCity ? 'input-reverse refund-input' : 'error-required error-input-reverse'}`} name="city" type="text" required value={city} onChange={handleCityChange} onFocus={handleFocus} onBlur={handleBlur}/>
                            <input className={`refund-input-text ${okProv ? 'refund-select input-forward' : 'error-required error-input-forward'}`} type="text" name='provincia' value={prov} onChange={(event) => {event.preventDefault();setProv(event.target.value);}} required/>
                            {suggestions.length > 0 && (
                                <div className='input-city-suggestions'>
                                    {suggestions.map((suggestion, index) => (
                                        <React.Fragment key={index}>
                                            <div className='suggestion-container' onClick={() => handleSuggestionClick(suggestion)}>
                                                <h4>{suggestion.nome} ({suggestion.provincia})</h4>
                                            </div>
                                            {index < suggestions.length - 1 && <hr/>}
                                        </React.Fragment>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>

                    <div className='refund-input-container'>
                        <label className='refund-label' htmlFor="cap">Cap <span className="refund-required">*</span></label>
                        <select className={`refund-inline-padding ${okCap ? 'refund-input ' : 'error-required error-height'}`} name="cap" required>
                            <option value="" disabled selected>Seleziona</option>
                            {capSuggestions.map((cap, index) => (
                                <option key={index} value={cap}>{cap}</option>
                            ))}
                        </select>
                    </div>

                    <div className='refund-input-container'>
                        <label className='refund-label' for="address">Indirizzo e civico<span className="refund-required">*</span> </label>
                        <div className='refund-input-split'>
                            <select className={`refund-inline-padding street-input ${okAddress ? 'refund-select input-reverse' : 'error-required error-input-reverse error-select'}`} name='street'>
                                <option value="Via" selected>Via</option>
                                <option value="Viale">Viale</option>
                                <option value="Piazza">Piazza</option>
                                <option value="Largo">Largo</option>
                                <option value="Corso">Corso</option>
                                <option value="Vicolo">Vicolo</option>
                                <option value="Contrada">Contrada</option>
                                <option value="Altro">Altro</option>
                            </select>
                            <input className={`${okAddress  ? 'refund-input input-forward' : 'error-required  error-input-forward'}`} name="address" type="text" required/>
                        </div>
                    </div>

                    <div className='refund-input-container'>
                        <label className='refund-label' for="contact">Contatto <span className="refund-required">*</span> </label>
                        <input className={`${okContact  ? 'refund-input' : 'error-required'}`} name="contact" type="text" required/>
                    </div>

                    <div className='refund-input-container'>
                        <label className='refund-label' for="tel">Numero di telefono <span className="refund-required">*</span> </label>
                        <div className='refund-input-split'>
                            <div className={`prefisso-input ${okTel ? 'refund-select input-reverse' : 'error-required error-input-reverse error-select'}`} >+39 </div>
                            <input className={`${okTel ? 'refund-input input-forward' : 'error-required  error-input-forward'}`} name="tel" type="number" required/>
                        </div>
                    </div>

                    <div className='refund-input-container'>
                        <label className='refund-label' for="email">Email <span className="refund-required">*</span> </label>
                        <input className={`${okMail  ? 'refund-input' : 'error-required'}`} name="mail" type="email" required/>
                    </div>


                    <div className='refund-input-container'>
                        <label className='refund-label long-label' for="riff">Riferimento ordine o riferimento fattura<span className="refund-required">*</span> </label>
                        <input className={`${okRif  ? 'refund-input' : 'error-required'}`} name="rif" type="text" required/>
                    </div>

                    {inputSets.map((set, index) => (
                        <div key={index} className='refund-input-container-2 refund-orders'>
                            <div className='refund-input-container'>
                                <label className='refund-label' htmlFor={`cod-${index}`}>Codice prodotto<span className="refund-required">*</span></label>
                                <input className={`${set.isValid ? 'refund-input' : 'error-required'}`} name={`cod-${index}`} type="text" required value={set.cod} onChange={(e) => handleInputChange(index, 'cod', e.target.value)}/>
                            </div>

                            <div className='refund-input-container'>
                                <label className='refund-label' htmlFor={`serial-${index}`}>Seriale prodotto (opzionale)</label>
                                <div className='refund-input-split gap-split'>
                                    <input className='refund-input' name={`serial-${index}`} type="text" value={set.serial} onChange={(e) => handleInputChange(index, 'serial', e.target.value)}/>
                                    {index === 0 ? (
                                        <button className="add-remove-button" onClick={event => { event.preventDefault(); handleAddInputs()}}>Aggiungi</button>
                                    ) : (
                                        <button className="add-remove-button" onClick={event => { event.preventDefault(); handleRemoveInputs(index)}}>Rimuovi</button>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}

                    <div className='refund-input-container-2'>
                        <label className='refund-label' for="dif">Difetto<span className="refund-required">*</span> </label>
                        <textarea className={`${okDif  ? 'refund-textarea': 'error-textarea'}`} name="dif" required></textarea>
                    </div> 

                    <hr className='separator'></hr>

                    <h2>Informazioni sul ritiro</h2>
                    <div className='refund-input-container-2'>
                        <label className='refund-label' for="colli">Totale colli della spedizione<span className="refund-required">*</span> </label>
                        <input className={`${okColli  ? 'refund-input' : 'error-required'}`} name="colli" type="number" required/>
                    </div>

                    <div className='refund-date'>
                        <div className='refund-input-container-2'>
                        <label className='refund-label'>Giorni <span className="refund-required">*</span><span className='title-error-2'>per favore inserisci almeno un giorno</span></label>
                            <div className='refund-input-split split-date'>
                                <div>
                                    <input type='checkbox' name='lun'></input>
                                    <label for="lun">Lunedí</label>
                                </div>
                                <div>
                                    <input type='checkbox' name='mar'></input>
                                    <label for="mar">Martedí</label>
                                </div>
                                <div>
                                    <input type='checkbox' name='mer'></input>
                                    <label for="mer">Mercoledí</label>
                                </div>
                                <div>
                                    <input type='checkbox' name='gio'></input>
                                    <label for="gio">Giovedí</label>
                                </div>
                                <div>
                                    <input type='checkbox' name='ven'></input>
                                    <label for="ven">Venerdí</label>
                                </div>
                                <div>
                                    <input type='checkbox' name='sab'></input>
                                    <label for="sab">Sabato</label>
                                </div>
                            </div>
                        </div>

                        <div className='refund-input-container-2'>
                        <label className='refund-label'>Orari mattina</label>
                            <div className='refund-input-split'>
                                <input className={`${okAm  ? 'refund-input input-reverse' : 'error-required error-input-reverse error-height'}`} type="time" name='am' required/>
                                <input className={`${okAc  ? 'refund-input input-forward' : 'error-required error-input-forward error-height'}`} type="time" name='ac' required/>
                            </div>
                        </div>

                        <div className='refund-input-container-2'>
                            <label className='refund-label'>Orari pomeriggio</label>
                            <div className='refund-input-split'>
                                <input className={`${okPm  ? 'refund-input input-reverse' : 'error-required error-input-reverse error-height'}`} type="time" name='pm' required/>
                                <input className={`${okPc  ? 'refund-input input-forward' : 'error-required error-input-forward error-height'}`} type="time" name='pc' required/>
                            </div>
                        </div>
                    </div>


                    <div className='refund-input-container-2 captcha-container'>
                        <label className='refund-label-captcha'>Inserisci il codice<span className="refund-required-captcha">*</span></label>
                        <LoadCanvasTemplateNoReload/> 
                        <input className={`${okCaptcha  ? 'refund-input' : 'error-required'}`} type='text' name='captcha' value={captcha} onChange={(event) => {event.preventDefault();setCaptcha(event.target.value);}} required/>
                    </div>

                    <div className='refund-input-container-2'>
                        <button onClick={event => { event.preventDefault(); sendData();}}>Invia richiesta</button>
                    </div>

                </form>
            </div>
        </div>
    );
}

export default Refund;